"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var GlobalNavigation = function GlobalNavigation(_ref) {
  var _ref$apiKey = _ref.apiKey,
      apiKey = void 0 === _ref$apiKey ? "" : _ref$apiKey,
      _ref$disable = _ref.disable,
      disable = void 0 === _ref$disable ? !1 : _ref$disable;
  (0, _react.useEffect)(function () {
    if (!disable) {
      // Make sure script hasn't already been injected
      if (!document.getElementById("idGlobalNavigation")) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://www.service.nsw.gov.au/assets/global-nav-embed-api.js?apikey=" + apiKey;
        script.id = "idGlobalNavigation";
        document.body.appendChild(script);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

GlobalNavigation.defaultProps = {
  apiKey: "",
  disable: !1
};
GlobalNavigation.propTypes = {
  apiKey: _propTypes.default.string,
  disable: _propTypes.default.bool
};
var _default = GlobalNavigation;
exports.default = _default;